import { EmptyPosition } from "./EmptyPosition";
import { EmptyPositionT } from "./EmptyPosType";
import React from "react";
import { WidgetPosWithSubs } from "../types";
import { findEmptyPositions } from "./findEmptyPositions";
import { SharedValue, useDerivedValue } from "react-native-reanimated";

const tiles = new Array(16)
  .fill(0)
  .map(() => ({ active: false, x: 0, y: 0, c: 0, w: 0, h: 0 }));

function EmptyPositionsC(props: {
  positions: SharedValue<WidgetPosWithSubs[]>;
  columnHorizontalPadding: number;
  unitSize: number;
  onRequestAdd: (pos: EmptyPositionT) => void;
}) {
  const positions = useDerivedValue(() => {
    const emptyPos = findEmptyPositions(props.positions.value);
    return tiles.map((tile, i) =>
      emptyPos[i] ? { ...emptyPos[i], active: true } : tile
    );
  });

  return (
    <>
      {tiles.map((pos, index) => (
        <EmptyPosition
          key={index}
          positions={positions}
          positionIndex={index}
          unitSize={props.unitSize}
          spaceBetweenColumns={props.columnHorizontalPadding}
          onPress={props.onRequestAdd}
        />
      ))}
    </>
  );
}
export const EmptyPositions = React.memo(EmptyPositionsC);
